import formMapper from "@mappers/Modules/faq/FaqItem.mapper";
import createItemAPI from "@services/Faq/createFaq";
import Create from "@shared/FormTemplates/Create";
import validator from "@validators/Modules/faq/faq.validate";
import { ReactElement } from "react";
import CreateForm from "./CreateForm";

const CreateItem = (): ReactElement => (
  <Create
    CustomForm={CreateForm}
    createHook={createItemAPI}
    validator={validator}
    formMapper={formMapper}
  />
);

export default CreateItem;
